const MobileNavActionTypes = {
  TOGGLE_NAV: "TOGGLE_NAV",
};

export default MobileNavActionTypes;
